module.exports = __webpack_public_path__ + "img/rkhy-xr.2a85468a.png";